import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Grid } from 'semantic-ui-react';
import { formValueSelector, getFormSubmitErrors } from 'redux-form';
import _ from 'lodash';

import { Main, Filter } from 'Containers';
import { TitledCard, LoadingPage } from 'Components';
import { VENDOR_ELECTRONIC_FILE_CONFIG_NAME } from 'Common/FormEnum';
import { errorToast, createToast, toastType } from 'Common/ToastHelper';
import { getIsDirty } from 'Common/Selectors/DirtySelector';
import { VendorEleFileConfigFieldEnum as Fields } from 'Common/FieldEnum';
import { VendorElectronicFileTypesEnum as FileTypes } from 'Common/Constants/Enumeration/VendorElectronicFileTypesEnum';
import { submitForm, resetForm } from 'State/forms/actions';
import { actions } from '../state/actions';
import ElectronicFileConfigForm from '../components/ElectronicFileConfigForm';
import {
  vendorEleFileConfigInitialValues,
  vendorEleFileConfigSubmitValues,
} from './../helpers';

class ElectronicFileConfigContainer extends Component {
  static path = '/vendorsetup/elefileconfig/:id';

  componentDidMount() {
    const { id } = this.props.match.params;
    if (id !== '0') {
      this.props.fetchVendorEleFileConfig(id);
    }
  }

  componentDidUpdate(prevProps) {
    const { clearVendorElectronicFileConfigErrorSuccess } = this.props;
    if (errorToast(this.props, prevProps, 'submitError')) {
      clearVendorElectronicFileConfigErrorSuccess();
    } else if (errorToast(this.props, prevProps, 'fetchError')) {
      clearVendorElectronicFileConfigErrorSuccess();
    } else if (this.props.submitted && !prevProps.submitted) {
      createToast(
        toastType.success,
        'Success',
        'Electronic file configuration has been saved',
        true
      );
      clearVendorElectronicFileConfigErrorSuccess();
    }
  }

  componentWillUnmount = () => {
    const { resetForm, clearVendorElectronicFileConfigData } = this.props;
    resetForm(VENDOR_ELECTRONIC_FILE_CONFIG_NAME);
    clearVendorElectronicFileConfigData();
  };

  getMainProps = () => {
    const { submitting, isReadOnly, formHasErrors } = this.props;
    return {
      toolbox: {
        backButtonProps: { shown: true, path: '/vendorsetup/' },
        rightButtons: [
          {
            content: 'Save',
            disabled: submitting || isReadOnly || formHasErrors,
            loading: submitting,
            onClick: this.onSaveClick,
          },
        ],
        shown: true,
      },
    };
  };

  onSaveClick = () => {
    this.props.scrollMainTo(0, 0);
    this.props.submitForm(VENDOR_ELECTRONIC_FILE_CONFIG_NAME);
  };

  handleMainSubmit = model => {
    if (validate(model)) {
      return this.props.saveElectronicFileConfig(
        vendorEleFileConfigSubmitValues(model)
      );
    }
  };

  render() {
    const { id } = this.props.match.params;
    const {
      fetching,
      configData,
      isReadOnly,
      fileFormat,
      fileFields,
      customerInfo,
    } = this.props;
    return (
      <Fragment>
        {fetching && <LoadingPage />}
        <Filter title="Electronic File Configuration" />
        <Main {...this.getMainProps()} shouldNotUsePageWidth>
          <Grid>
            <Grid.Column>
              <Grid.Row>
                <TitledCard title={'File Format'}>
                  {configData && (
                    <ElectronicFileConfigForm
                      initialValues={vendorEleFileConfigInitialValues(
                        configData,
                        id
                      )}
                      isReadOnly={isReadOnly}
                      onSubmit={this.handleMainSubmit}
                      configData={configData}
                      fileFormat={fileFormat}
                      fileFields={fileFields}
                      customerInfo={customerInfo}
                    />
                  )}
                </TitledCard>
              </Grid.Row>
            </Grid.Column>
          </Grid>
        </Main>
      </Fragment>
    );
  }
}

export const validate = data => {
  let isValid = true;
  if (!data || !data[Fields.FileFormat]) {
    createToast(toastType.error, 'Error', 'File type is required', true);
    isValid = false;
  } else if (FileTypes.FixedLength === data[Fields.FileFormat]) {
    if (data[Fields.FileFields] && data[Fields.FileFields].length > 0) {
      _.each(data[Fields.FileFields], field => {
        if (!field[Fields.IdLength] && isValid) {
          createToast(
            toastType.error,
            'Error',
            'Field Length is required if File Format type is Fixed Length',
            true
          );
          isValid = false;
        }
      });
    }
  }
  return isValid;
};

const selector = formValueSelector(VENDOR_ELECTRONIC_FILE_CONFIG_NAME);
const mapStateToProps = (state, ownProps) => {
  const { eleFileConfig } = state.VendorSetupState;
  const formErrors = getFormSubmitErrors(VENDOR_ELECTRONIC_FILE_CONFIG_NAME)(
    state
  );
  ownProps.setPageLevelDirty(
    getIsDirty(VENDOR_ELECTRONIC_FILE_CONFIG_NAME)(state)
  );
  return {
    configData: eleFileConfig.configData,
    formHasErrors: formErrors ? Object.keys(formErrors).length > 0 : false,
    fetching: eleFileConfig.fetching,
    fetchError: eleFileConfig.fetchError,
    submitted: eleFileConfig.submitted,
    submitting: eleFileConfig.submitting,
    submitError: eleFileConfig.submitError,
    fileFormat: selector(state, [Fields.FileFormat]),
    fileFields: selector(state, [Fields.FileFields]),
    customerInfo: selector(state, [Fields.CustomerInfo]),
  };
};
const mapDispatchToProps = { ...actions, submitForm, resetForm };
export const ElectronicFileConfig = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ElectronicFileConfigContainer)
);



// WEBPACK FOOTER //
// ./src/pages/inventory/vendorsetup/subpages/ElectronicFileConfig.js